// extracted by mini-css-extract-plugin
export default {"container":"RaceStatus_container__9P543","closed":"RaceStatus_closed__VHyi7"};